export default "__VITE_ASSET__DXSJ076C__"